import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../store';

const initialState = {
  menu: [],
  season: '',
  marketLine: '',
  warehouse: {
    id: '',
    code: '',
    name: '',
  },
  zone: '',
  orderNumber: '',
  orderId: '',
  isSeasonNewest: false,
  barColor: '',
  showSold: localStorage.getItem('showSold') === 'true',
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setMenu(state, action) {
      state.menu = action.payload;
    },
    setSeason(state, action) {
      state.season = action.payload;
    },
    setMarketLine(state, action) {
      state.marketLine = action.payload;
    },
    setWarehouse(state, action) {
      state.warehouse = action.payload;
    },
    setZone(state, action) {
      state.zone = action.payload;
    },
    setOrderNumber(state, action) {
      state.orderNumber = action.payload;
    },
    setOrderId(state, action) {
      state.orderId = action.payload;
    },
    setLatestSeason(state, action) {
      if (!state.season) return;

      state.isSeasonNewest = state.season === action.payload.season;
    },
    setBarColor(state, action) {
      state.barColor = action.payload;
    },
    setShowSold(state, action) {
      localStorage.setItem('showSold', action.payload);
      state.showSold = action.payload;
    },
  },
});

export const getState = (rootState: RootState) => rootState.settings;

export const {
  setMenu,
  setSeason,
  setMarketLine,
  setWarehouse,
  setZone,
  setOrderNumber,
  setOrderId,
  setLatestSeason,
  setBarColor,
  setShowSold,
} = settingsSlice.actions;
